<template>
    <div class="column-center wapp" :class="{'full':isFull,'kuan':iskuan}">
        <div class="title" v-if="!isFull&&this.$route.params.name!='PowerDistribution'&&this.$route.params.name!='PowerDistribution'">一次系统图</div>
        <div class="site">
            <span class="wiringItem" v-for="(item,index) in $store.getters.getTypeSite('distribution')" :key="item.areaId" :class="active==index?'active':''" @click="tagsite(index)" >{{item.areaName}}</span>
            <div class="boxSite">
                <span v-for="(item,index) in 3" :key="index + 10"></span>
                <span>{{$store.getters.getTypeSite('distribution')[active].areaName + ' ' + diagramName}}</span>
                <span v-for="(item,index) in 3" :key="index"></span>
            </div>
        </div>
        <div class="diagram" >
            <iframe v-if="diagramUrl" ref="iframe" height="100%" width="100%"  class="small" :src="diagramUrl" frameborder="0"></iframe>
            <div v-else class="nothing"></div>
            <div class="handel">
                <!-- <img src="@/assets/img/kuan.png" alt=""  v-if="!isFull"  @click="kuan"> -->
                <img src="@/assets/img/quan.png" alt="" v-if="!iskuan"  @click="full"> 
            </div>
        </div>
        <div class="Wiring site" >
            <span class="wiringItem1" v-for="(item,index) in $store.getters.getTypeSite('distribution')[active].wiringList" :key="index" :class="active1==index?'active':''" @click="tagsite1(index,item)" :title="item.diagramDesc">{{item.diagramDesc}}</span>
            <div class="box">
                <span v-for="(item,index) in 10" :key="index"></span>
            </div>
        </div>
    </div>
</template>

<script>
import { getProjectwirings } from '../../../api/power'
export default {
    props:['siteList'],
    data(){
        return {
            isFull:false,
            iskuan: false,
            active:0,
            active1:0,
            diagramUrl:null,//接线图
            diagramName:'',// 当前接线图名字
        }
    },
    watch:{
		'$store.getters.areaId'(areaId){
            this.$store.getters.getTypeSite('distribution').forEach((item ,index) =>{
                if(item.areaId == areaId){
                    this.tagsite(index)
                }
            })
		}
	},
    created(){
        if(this.$route.params.name=='Overview'||this.$route.params.name=='WorkBench'){
            this.$store.commit('setAreaId', this.$store.getters.getTypeSite('distribution')[0].areaId)
            this.$store.commit("setAreaInfo", this.$store.getters.getTypeSite('distribution')[0]);
        }
        this.$store.getters.getTypeSite('distribution').forEach((item,index)=>{
            if(item.areaId == this.$store.getters.areaId){
                this.tagsite(index)
            }
        })
        // console.log(this.$store.getters.getTypeSite('distribution'));
    },
    methods:{
        tagsite1(index, item){
            this.active1 = index
            if(item){
                this.diagramUrl = item.uploadFileUrl
                this.diagramName = item.diagramDesc
            }else{
                this.diagramUrl = null
            }
        },
        tagsite(index){
            this.active = index
            this.tagsite1(0, this.$store.getters.getTypeSite('distribution')[index].wiringList[0])
            this.$store.commit('setAreaId', this.$store.getters.getTypeSite('distribution')[index].areaId)
            this.$store.commit("setAreaInfo", this.$store.getters.getTypeSite('distribution')[index]);
        },
        kuan(){
            this.iskuan = !this.iskuan
        },
        full() {
            this.isFull = !this.isFull
        }
    }
}
</script>

<style lang="less" scoped>
    
            .wapp{
                width: 100%;
                height: 100%;
                background: #fff;
                justify-content: space-between;
                position: relative;
                .title{
                    height: 50rem;
                    line-height: 50rem;
                    padding: 0 24px;
                    font-size: 18rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #333333;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    width: 100%;
                }
            }
            .full {
                width: 100vw;
                height: 100vh;
                position: fixed;
                top: 0;
                left: 0;
                z-index: 9999;
                .diagram{
                    height:calc(100% - 100rem);
                }
            }

            .kuan {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 999;
            }
            .site{
                width: 100%;
                height: 40rem;
                position: relative;
                top: 0;
                left: 0;
                display: flex;
                flex-direction: row;
                .wiringItem, .wiringItem1{
                    width: 10%;
                    height: 100%;
                    background: #FFFFFF;
                    border: 1px solid #0D94FF;
                    border-radius: 4px;
                    font-size: 14rem;
                    font-weight: 500;
                    color: #0E9CFF;
                    display: inline-block;
                    text-align: center;
                    line-height: 40rem;
                    padding: 0 5rem;
                    cursor: pointer;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    z-index: 11;
                }
                .wiringItem:nth-child(4){
                    margin-left: 40%;
                }
                .active{
                    background: #0E9CFF;
                    color: #ffffff
                }
                .box{
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    flex-direction: row;
                    &>span{
                        width: 10%;
                        height: 100%;
                        display: inline-block;
                        background: #FFFFFF;
                        border: 1px solid #0D94FF;
                        border-radius: 4px;
                        cursor: no-drop;
                    }
                }
                .boxSite{
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    flex-direction: row;
                    &>span{
                        width: 10%;
                        height: 100%;
                        display: inline-block;
                        background: #FFFFFF;
                        border: 1px solid #0D94FF;
                        border-radius: 4px;
                        cursor: no-drop;
                    }
                    &>span:nth-child(4){
                        width: 40%;
                        background: #6DC8EC;
                        border-radius: 4px;
                        font-size: 16rem;
                        font-family: Source Han Sans SC;
                        font-weight: 800;
                        color: #FFFFFF;
                        line-height: 40rem;
                        text-align: center;
                        cursor: default;
                    }
                }
            }
            .Wiring{
                bottom: 0;
                top: auto
            }
            .diagram{
                height:calc(100% - 132rem);
                width: 100%;
                // padding: 20rem;
                position: relative;
                .handel{
                    position: absolute;
                    bottom: 7px;
                    right: 10px;
                    img{
                        margin:0 10rem;
                        cursor: pointer;
                    }
                }
                .nothing{
                    position: absolute;
                    top: 30%;
                    left: 0%;
                    right: 0%;
                    margin: auto;
                    width: 25%;
                    height: 30%;
                    background: url('../../../assets/img/not_found_data.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
</style>